export const data= [
    {
      id: 1,
      name: 'Deliligin Tarihi',
      image:
        'https://img.kitapyurdu.com/v1/getImage/fn:11276747/wh:true/miw:200/mih:200',
    },
    {
      id: 2,
      name: 'Hapishanenin Dogusu',
      image:
        'https://img.kitapyurdu.com/v1/getImage/fn:8063241/wh:true/wi:800',
    },
    {
      id: 3,
      name: 'Kelimeler ve Seyler',
      image:
        'https://img.kitapyurdu.com/v1/getImage/fn:3767170/wh:true/miw:200/mih:200',
    },
    {
      id: 4,
      name: 'Kendini Bilmek',
      image:
        'https://img.kitapyurdu.com/v1/getImage/fn:11576445/wh:true/wi:800',
    },
    {
      id: 5,
      name: 'Toplumu Savunmak Gerekir',
      image:
        'https://0.academia-photos.com/attachment_thumbnails/49036635/mini_magick20190201-25016-1yqtkju.png?1549075775',
    },
    {
      id: 6,
      name: 'Hakikat Cesareti',
      image:
        'https://bilgiyay.com/wp-content/uploads/2019/01/hakikat-cesareti-1-2.png',
    }
  ];